import {
  useState,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Popover, Whisper } from "rsuite";
import { callFunctionIfExists } from "utils/GeneralUtils";
import Location from "./Location";

const LocationCreate = (
  { field, type, existingValue, inputSize, onChange, disabled },
  ref
) => {
  const [isEditing, setIsEditing] = useState(false);
  const [optionsOpen, setOptionsOpen] = useState(false);
  const [locations, setLocations] = useState(existingValue || []);
  const [fullScreen, setFullScreen] = useState(false);

  const whisperRef = useRef();

  const startEditing = () => {
    whisperRef.current?.open();
  };

  const save = (newLocations) => {
    setLocations(newLocations);
    callFunctionIfExists(onChange, newLocations);
  };

  useEffect(() => {
    setLocations(existingValue ? structuredClone(existingValue) : []);
  }, [existingValue]);

  useImperativeHandle(ref, () => ({
    focus: () => {
      startEditing();
    },
  }));

  return (
    <Whisper
      preventOverflow
      ref={whisperRef}
      placement="autoVertical"
      trigger={isEditing && !optionsOpen ? "click" : "none"}
      onOpen={() => setIsEditing(true)}
      onClose={() => whisperRef?.current?.close()}
      speaker={
        <Popover
          className="sidebar-popover pt-2 px-0 pb-0 m-0"
          style={{
            width: fullScreen ? 700 : 350,
            maxHeight: "90vh",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <Location
            locations={locations}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
            setOptionsOpen={setOptionsOpen}
            field={field}
            onClose={() => whisperRef?.current?.close()}
            defaultOpen
            save={save}
            existingValues={locations}
          />
        </Popover>
      }
    >
      <div
        style={{
          height:
            inputSize === "sm"
              ? "calc( 0.45em + 1.25rem + 5px)"
              : "calc( 1.5em + 1.25rem + 5px)",
          borderRadius: "0.25rem",
          fontSize: "0.875rem",
          lineHeight: 1.5,
          padding: inputSize === "sm" ? "0.25rem 0.5rem" : "0.625rem 0.75rem",
          overflowY: "hidden",
          background: disabled ? "#c6cac7" : "unset",
          cursor: disabled ? "not-allowed" : "pointer",
        }}
        className="border w-100"
        onClick={() => startEditing()}
      >
        <div className="text-truncate">
          {!locations || locations?.length < 1
            ? "--"
            : locations.map((location, i) => (
                <span key={i}>
                  {location?.Readable}
                  {i + 1 === locations.length ? null : ", "}
                </span>
              ))}
        </div>
      </div>
    </Whisper>
  );
};

export default forwardRef(LocationCreate);
